import { useMutation, useQueryClient } from 'react-query';
import listedKitService from 'resources/listedkit/listedkit.service';


export default function useListedKitUpdate() {
  const queryClient = useQueryClient();
  const currentUser = queryClient.getQueryData(['user.currentUser']);

  return useMutation(
    (requestData) => listedKitService.updateListedKit(requestData),
    {
      onSuccess: (response) => {
        if (!response || response.isBadRequest) {
          return;
        }

        queryClient.invalidateQueries(['listedKits.getById', response.id]);
        queryClient.invalidateQueries(['listedKits.getByCompanyId', response.company_id]);
        queryClient.invalidateQueries(['templates.defaultTemplates', response.company_id]);
        queryClient.invalidateQueries(['milestones.getKitMilestonesWithTasks', response.id]);
        queryClient.invalidateQueries(['milestones.getAllKitsMilestonesWithTasks', response.company_id]);
        queryClient.invalidateQueries(['audits.getKitAudits', response.id]);
        queryClient.invalidateQueries(['audits.getAllKitsAudits', response.company_id]);
        queryClient.invalidateQueries(['listedKits.getGhost', currentUser.company_id]);
        queryClient.invalidateQueries(['milestone.milestoneTemplates', currentUser.company_id]);
      },
    },
  );
}
